import { render, staticRenderFns } from "./SnapshotREST.vue?vue&type=template&id=79f00bbe"
import script from "./SnapshotREST.vue?vue&type=script&lang=js"
export * from "./SnapshotREST.vue?vue&type=script&lang=js"
import style0 from "./SnapshotREST.vue?vue&type=style&index=0&id=79f00bbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports